import { Tag } from 'antd'
import { createStyles } from 'antd-style'

import { SupplyDemandType } from '@eastcoal/shared/enums/SupplyDemandType'

import { SupplyDemandTagProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  tag: {
    margin: 0,
    paddingInline: token.paddingXXS,
    lineHeight: '16px'
  }
}))

export const SupplyDemandTag = ({ type }: SupplyDemandTagProps) => {
  const { styles } = useStyles()

  return (
    <Tag
      className={styles.tag}
      color={type === SupplyDemandType.SUPPLY ? 'blue' : 'red'}
    >
      {type === SupplyDemandType.SUPPLY ? '供' : '需'}
    </Tag>
  )
}
